import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1V2C1.79086 2 0 3.79086 0 6V14C0 16.2091 1.79086 18 4 18H14C16.2091 18 18 16.2091 18 14V6C18 3.79086 16.2091 2 14 2V1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1V2H10V1C10 0.447715 9.55229 0 9 0C8.44771 0 8 0.447715 8 1V2H6V1ZM12 4H10V5C10 5.55228 9.55229 6 9 6C8.44771 6 8 5.55228 8 5V4H6V5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5V4C2.89543 4 2 4.89543 2 6V8H16V6C16 4.89543 15.1046 4 14 4V5C14 5.55228 13.5523 6 13 6C12.4477 6 12 5.55228 12 5V4ZM2 14V10H16V14C16 15.1046 15.1046 16 14 16H4C2.89543 16 2 15.1046 2 14Z",
		fill: "#999999"
	})
});
export default SvgDate;
